'use client';

import React from 'react';
import round from 'lodash/round';
import TopSection from '../TopSection';
import SvgMoney from '../SvgMoney';
import SvgBuilding from '../SvgBuilding';
import { CityContextType } from '@/types/city';
import { numberToUpper } from '@/utils/numbers';

const Top = ({
  name,
  avg,
  adjacent_cities,
  market_share,
}: Pick<
  CityContextType,
  'name' | 'avg' | 'adjacent_cities' | 'market_share'
>) => {
  const rank = adjacent_cities.find((item) => item.current_city)?.rank || 0;

  const rangeData = React.useMemo(() => {
    const totalCount = market_share
      .map(({ count }) => count)
      .reduce((a, b) => a + b, 0);

    return {
      name: market_share[0].name,
      ratio: Math.round((market_share[0].count / totalCount) * 100),
    };
  }, [market_share]);

  return (
    <TopSection
      navList={[{ name: '城市概况' }]}
      title={name}
      subTitle="基于近 6 个月实时招聘数据，全景解析城市薪资水平、行业趋势与人才需求，助你规划职业发展路径。"
      cardList={[
        {
          title: '平均月薪',
          content: `¥${round(avg, -2)}`,
          subContent: `城市薪酬排名第${numberToUpper(rank)}`,
          icon: <SvgMoney />,
        },
        {
          title: '热招行业',
          content: rangeData.name,
          subContent: `占开放岗位约 ${rangeData.ratio}%，需求最高`,
          icon: <SvgBuilding />,
        },
      ]}
    />
  );
};

export default Top;
